import { NgIf, NgFor, CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'emi-validation-list-table',
  standalone: true,
  imports: [MatTooltipModule, TranslateModule, NgIf, NgFor, CommonModule],
  templateUrl: './validation-list-table.component.html',
  styleUrls: ['./validation-list-table.component.css']
})
export class ValidationListTableComponent implements OnInit, OnChanges {
  @Input() validationData: Array<any> = [];
  public StatusValidation = {
    success: "success",
    wrong: "wrong",
    scheduled: "scheduled"
  }
  public listValidation: Array<any> = [];
  public defaultList: Array<any> = [
    {
      type: "liveness.face",
      status: "scheduled"
    },
    {
      type: "match.face",
      status: "scheduled"
    },
    {
      type: "match.location",
      status: "scheduled"
    }
  ];
  constructor() { }

  ngOnInit() {

  }

  ngOnChanges() {
    this.listValidation = this.validationData;
    this.formatListValidation();
  }

  public formatListValidation() {
    if (this.listValidation.length <= 0) {
      this.listValidation = this.defaultList;
    } else {
      const nuevoArray = this.updateList(this.defaultList, this.listValidation);
      this.listValidation = nuevoArray;
    }
  }

  private updateList(defaultList: any[], nuevoArray: any[]): any[] {
    return defaultList.map(item => {
      const newItem = nuevoArray.find(newItem => newItem.type === item.type);
      return newItem ? { ...item, ...newItem } : item;
    });
  }
}
